import { useEffect } from 'react';
import { useLocation, useNavigate } from '@tanstack/react-router';
import { useAuthStore } from '@/store/auth.store';

export function useSessionExpiredRedirect() {
  const accessToken = useAuthStore((state) => state.accessToken);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!accessToken && !location.pathname.startsWith('/login')) {
      void navigate({
        to: '/login',
        replace: true,
        search: { redirect: location.href },
      });
    }
  }, [accessToken, navigate, location.pathname, location.href]);
}
